"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var DoubleRightOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M206.912 115.904l2.773 2.41L577.26 465.324a64 64 0 012.602 90.453l-2.56 2.603-367.594 347.306a42.667 42.667 0 01-61.184-59.392l2.56-2.645L502.25 511.851 151.104 180.352a42.667 42.667 0 01-4.139-57.515l2.411-2.773a42.667 42.667 0 0157.557-4.181zm277.333 0l2.774 2.41 367.573 347.009a64 64 0 012.603 90.453l-2.56 2.603L487.04 905.685a42.667 42.667 0 01-61.184-59.392l2.56-2.645 351.168-331.797-351.147-331.499a42.667 42.667 0 01-4.138-57.515l2.41-2.773a42.667 42.667 0 0157.536-4.16z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
DoubleRightOutlined.displayName = "DoubleRightOutlined";
var _default = exports["default"] = DoubleRightOutlined;